import {apiRequest} from "../helpers/utils";
import {dashboardMetrics} from '../components/dashboard/dashboardMetrics';

export const reportServices = {
    getReport,
    getTopReport,
    getCountryReport,
    getChartData,
    getDetailsReport
};

function getTopReport({groupBy, metric = 'revenue', ...filters}) {
    const orderBy = dashboardMetrics.some(item => item.key === metric) ? metric : 'revenue';
    return getReport({
        ...filters, groupBy, page: 1, pageSize: 5, orderBy, sortBy: 'DESC',
        columns: [groupBy === 'offer_id' ? 'offer_name' : 'campaign_name',
            ...dashboardMetrics.map(item => `metric_${item.key}`), 'metric_roi']
    });
}

async function getCountryReport({from, to, timezone, currencyCode, workspace}) {
    const records = [];
    const pageSize = 300;
    let page = 1;
    while (true) {
        const result = await getReport({
            groupBy: "country", from, to, timezone, currencyCode, workspace,
            page, pageSize, orderBy: "", sortBy: "ASC",
            columns: ["dimCountry_name", "metric_visits", "metric_clicks", "metric_conversionsAll", "metric_revenue", "metric_cost", "metric_profit"]
        });
        const batch = result?.records || [];
        records.push(...batch);
        const effectivePageSize = Number(result?.recordsPerPage) || pageSize;
        if (Number.isFinite(result?.total?.totalRecords) && records.length >= result.total.totalRecords) return records;
        if (batch.length < effectivePageSize) return records;
        page += 1;
    }
}

function getReport(
    {
        groupBy = "",
        from = "",
        to = "",
        timezone = "Etc/UTC",
        name = "",
        tags = "",
        filterTrafficSources = "",
        isDeleted = 0,
        page = 1,
        pageSize = 100,
        orderBy = "",
        sortBy = "",
        currencyCode = "EUR",
        exportData = "",
        metricFilters = [],
        columns = [],
        workspace = ""
    }
) {
    let params = {
        groupBy,
        from,
        to,
        timezone,
        name,
        tags,
        isDeleted,
        page,
        pageSize,
        orderBy,
        sortBy,
        currencyCode,
        export: exportData,
        columns,
        workspace
    };

    // Add traffic source filter
    let trafficSources = [];
    if (filterTrafficSources !== undefined) {
        for (const filter of filterTrafficSources) {
            trafficSources.push(filter?.value?.toString());
        }
        params[`trafficSources`] = trafficSources;
    }

    // Add metric filters
    if (metricFilters?.length > 0) {
        // eslint-disable-next-line array-callback-return
        metricFilters.map((obj) => {
            for (const metric in obj) {
                params[`metricFilters[${metric}]`] = obj[metric];
            }
        });
    }

    return apiRequest("get", "v1/report", {}, params);
}

function getDetailsReport(params) {
    return apiRequest("get", "v1/report", {}, params);
}

function getChartData({groupBy, from, to, timezone, currencyCode, workspace}) {
    return apiRequest("get", "v1/report/chart", {}, {groupBy, from, to, timezone, currencyCode, workspace});
}
